import { render, staticRenderFns } from "./Alerter.vue?vue&type=template&id=38c413b8&"
import script from "./Alerter.vue?vue&type=script&lang=js&"
export * from "./Alerter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports